// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/select_arow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/ongoing.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/sold.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
scss
 */
 \$font-regular: 400;
 \$font-medium: 500;
 \$font-semiBold: 600;
 \$font-bold: 700;
 \$font-extraBold: 800;
 \$font-black: 900;
 
 \$mainBg: #F5F6FA;
 \$primary-color: #131F43;
 \$icon-bgcolor: #F6F6F6;
 \$text-graycolor: #727272;
 \$cardIcon1-bg: #F3F4F8;
 \$cardIcon1-darkbg: #30231a;
 \$cardIcon1-darkbg-icon: #9d785f;
 \$cardIcon2-bg: #FAF4FB;
 \$cardIcon2-darkbg: #13252a;
 \$cardIcon2-darkbg-icon: #3b606a;
 \$cardIcon3-bg: #FAF7F3;
 \$cardIcon3-darkbg: #2c1a27;
 \$cardIcon3-darkbg-icon: #6c4863;
 \$cardIcon4-bg: #F5F9FC;
 \$cardIcon4-darkbg: #241d3e;
 \$cardIcon4-darkbg-icon: #5f538b;
 \$cardIcon2-color: #AC44BB;
 \$cardIcon3-color: #D69A5F;
 \$cardIcon4-color: #176CA5;
 \$green-color: #38A169;
 \$darkGreen-color: #207a4a;
 \$placeholder-color: #666666;
 \$profile-dark-text: #181818;
 \$heading : #0B0D0F;
 \$light-gray : #999999;
 \$menu_icon : #CBCBCB;
 \$red-color : #F94747;
 \$red-hover : #960101;
 \$dark-active-blue : #3b82f6;
 \$dark-light-blue : #92afd3;
 \$addBtn-dark-blue : #3b82f6;
 \$addBtn-dark-blue-hover : #2563eb;
 \$backBtn-dark : #3b82f633;
 
 
 
 \$darkTheme_blue : #132337;
 \$darkTheme_darkBlue : #0f1824;
 \$darkTheme_selectBlue : #1c2e45;
 \$darkTheme_updateBtn : #0a2574;
 
 /* 
 Body Theme Color
  */
 \$lightthemecolor: #f3f6f9;
 \$darkthemecolor: #151521;
 
 \$white-color: #fff;
 \$black-color: #1d1d1d;
 \$fullBlack-color: #1d1d1d;
 \$lightthemetext: #60677e;
 
 /* 
 Dark Theme Colors
 */
 \$primarydark-color: #132337;
 
 /* 
 Button Theme
 */
 \$primary-btncolor: #131F43;
 \$secondary-btncolor: rgba(37, 105, 109, 0.864);
 
 \$tableheadlightbg: #e9eaf0;
 
 
 /* 
 Max Dashboard scss
 */
 \$dashboardwidth: calc(100% - 320px);
 \$dashboardposition: absolute;
 \$dashboardleft: 290px;
 \$dashboardpadding: 30px;
 
 /* 
 Min Dashboard scss
 */
 \$dashwidth: calc(100% - 50px);
 \$dashleft: 50px;
 
 /* 
 Max Dashboard scss
 */
 
 .dashboard {
   width: \$dashboardwidth;
   position: relative;
   left: \$dashboardleft;
   padding: \$dashboardpadding;
   border-radius: 8px;
   min-height: auto !important;
   background-color: \$mainBg;
   overflow-y: auto;
 }
 
 .dashboardContain {
   width: calc(100% - 320px);
   background-Color: \$mainBg;
   border-radius: 8px;
 }
 
 .bodythemedark .dashboardContain,
 .bodythemedark .dashboard,
 .bodythemedark .cont2 {
   background-Color: \$darkTheme_darkBlue;
 }
 
 .top_header .top_header_inner {
   background-color: transparent;
   height: auto;
   overflow-y: unset;
 }
 
 /* 
 Min Dashboard scss
 */
 
 .cont2 {
   width: \$dashwidth;
   left: \$dashleft;
   position: relative;
   padding: \$dashboardpadding;
   border-radius: 8px;
   background: \$mainBg;
   /*height: calc(100vh - 160px);*/
   height: 100%;
   min-height: auto !important;
   overflow-y: auto;
   /* 
 background-Color: \$dashboardbackgroundColor;
   padding-bottom: 8%;
 */
 }
 
 .subLink svg {
   position: relative;
   top: -2px;
   left: -7px;
 }
 
 
 
 .cst_vendr input {
   min-height: 35px !important;
 }
 
 .cst_vendr .form-control {
   background-color: #f5f6fa;
   border: none;
 }
 
 
 .footer {
   height: 70px;
 }
 
 body {
   background-color: \$white-color;
 }
 
 /* 
 THEME CHANGE
 */
 .bodythemelight {
   background-color: \$white-color;
   padding-top: 90px;
 }
 
 .bodythemedark {
   background-color: \$darkTheme_blue;
   padding-top: 90px;
 }
 
 /* 
 Header Navbar Theme
 */
 .headerthemelight {
   background-color: \$white-color;
 }
 
 .headerthemedark {
   background-color: \$darkTheme_blue;
 }
 
 .top_header {
   min-height: 90px;
   display: flex;
   align-items: center;
   position: fixed;
   width: 100%;
   z-index: 2;
   top: 0;
 }
 
 /* 
 LEFT MENU THEME CHANGE
 */
 .menuthemelight {
   background-color: \$white-color;
 }
 
 .menuthemedark {
   background-color: \$darkTheme_blue;
 }
 
 /* 
 LEFT MENU LINKS THEME CHANGE
 */
 .menulinklight span {
   color: \$placeholder-color !important;
 }
 
 .menulinklight a {
   color: \$menu_icon !important;
 }
 
 .menulinklight:hover span,
 .menulinklight:hover a {
   color: \$white-color !important;
 }
 
 .menulinkdarkSelected {
   background-color: \$darkTheme_selectBlue;
   color: \$dark-active-blue;
 }
 
 .menuthemelight .menulinklightSelected {
   /*background-color: \$lightthemecolor;*/
   color: \$white-color !important;
   background-color: \$primary-color !important;
 }
 
 .menulinkdark {
   color: \$dark-light-blue !important;
 }
 
 .menulinklight:hover {
   color: \$white-color !important;
   background-color: \$primary-color !important;
 }
 
 .menulinklight .sub_arrow svg path {
   stroke: \$menu_icon !important;
 }
 
 .menulinklight:hover .sub_arrow svg path {
   stroke: \$white-color !important;
 }
 
 .menulinkdark .sub_arrow svg path {
   stroke: \$dark-light-blue !important;
 }
 
 .menulinkdark:hover .sub_arrow svg path {
   stroke: \$white-color !important;
 }
 
 .menulinklight:hover svg path,
 .menulinklightSelected svg path {
   fill: #fff !important;
 }
 
 .menulinkdark:hover {
   background-color: \$darkTheme_selectBlue;
   color: \$white-color;
 }
 
 /* 
 BODY HEADERS
 */
 .headinglight {
   color: \$lightthemetext;
 }
 
 .headingdark {
   color: \$lightthemetext;
 }
 
 /* 
 SEARCH BOX THEME COLOR
 */
 .searchboxlight {
   background-color: \$white-color;
   border: none;
 }
 
 .searchboxdark {
   background-color: \$darkTheme_blue;
   color: \$white-color;
   border: none;
 }
 
 .searchboxdark::placeholder {
   color: \$lightthemetext;
 }
 
 /* 
 CUSTOM TABLE THEME COLOR
 */
 .tableheadlight {
   background-color: \$primary-color;
   border-radius: 5px 5px 0px 0px;
 }
 
 .tableheadlight th {
   color: \$white-color;
 }
 
 thead .tableheadlight th:first-child,
 thead .tableheaddark th:first-child {
   border-radius: 5px 0 0 0px;
 }
 
 thead .tableheadlight th:last-child,
 thead .tableheaddark th:last-child {
   border-radius: 0 5px 0px 0;
 }
 
 th:first-child {
   border-radius: 0px;
 }
 
 td:last-child {
   border-radius: 0px;
 }
 
 table.table.table-borderless {
   border-collapse: separate !important;
   border-spacing: 0 0px !important;
 }
 
 .tableheaddark {
   background-color: \$primarydark-color;
   color: \$white-color;
 }
 
 .table-borderless tr:nth-child(even) {
   background-color: #F9FAFB;
 }
 
 .table-borderless .left-section {
   padding-top: 10px;
 }
 
 .tablebodylight td,
 .tablebodydark td {
   padding: 0.5rem 1rem !important;
   line-height: 45px;
 }
 
 .tablebodylight {
   background-color: \$white-color;
 
   &:hover {
     background-color: \$white-color;
     cursor: auto;
   }
 }
 
 .tablebodydark {
   /* background-color: \$primarydark-color; */
   color: \$lightthemetext;
 
   &:hover {
     background-color: rgba(33, 150, 243, 0.1);
     cursor: pointer;
   }
 }
 
 /* 
 PAGINATION THEME COLOR
 */
 .paginationlight {
   color: \$lightthemetext !important;
   font-size: 13px !important;
 }
 
 .paginationdark {
   color: \$lightthemetext !important;
   font-size: 13px !important;
 }
 
 /* 
 SETTING FORM THEME COLOR
 */
 .formthemelight {
   background-color: \$white-color;
   color: \$black-color !important;
   box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);
 }
 
 .formthemedark {
   background-color: \$primarydark-color;
   color: \$lightthemetext !important;
   font-size: 14px;
 
   ::placeholder {
     color: \$lightthemetext;
   }
 }
 
 
 /* 
 VIEW FORM DETAILS BOX THEME COLOR
 */
 .viewformlight {
   background-color: \$lightthemecolor;
 }
 
 .permissionboxlight {
   background-color: #f8f9fa;
   border: 1px solid #dee2e6;
 }
 
 .permissionboxdark {
   background-color: \$darkTheme_darkBlue;
   border: solid 1px #242434;
 }
 
 .errormsgclr {
   color: red;
   font-size: 14px;
   margin-top: 5px;
 }
 
 /* 
 Graph theme
 */
 .graphclrlight {
   background-color: \$white-color;
 }
 
 .graphclrdark {
   background-color: \$primarydark-color;
 }
 
 
 /* 
 Counter theme
 */
 #card1bglight {
   /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
   background-color: \$white-color;
 }
 
 #card1bgdark {
   background: #392f28;
 }
 
 #card2bglight {
   /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
   background-color: \$white-color;
 }
 
 #card2bgdark {
   background: #1c3238;
 }
 
 #card3bglight {
   /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
   background-color: \$white-color;
 }
 
 #card3bgdark {
   background: #3a2434;
 }
 
 #card4bglight {
   /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
   background-color: \$white-color;
 }
 
 #card4bgdark {
   background: #2f264f;
 }
 
 #card1bgdark a,
 #card1bgdark p,
 #card2bgdark a,
 #card2bgdark p,
 #card3bgdark a,
 #card3bgdark p,
 #card4bgdark a,
 #card4bgdark p {
   color: \$white-color;
 }
 
 /* 
 Action button theme
 */
 .actionbtnlight {
   color: #46475bde;
 }
 
 .actionbtndark {
   color: \$lightthemetext;
 }
 
 
 /* 
 profile dropdowntheme
 */
 .profiledropdownlight {
   background-color: #fff;
 }
 
 .profiledropdowndark {
   background-color: #151521;
 }
 
 .settingsection #addform.formthemedark .savebtn {
   background-color: \$addBtn-dark-blue;
   color: \$white-color;
 }
 
 #addform.formthemedark .savebtn {
   background-color: \$addBtn-dark-blue;
   color: \$white-color;
 }
 
 .profile_conatiner {
   border-radius: 5px !important;
 }
 
 .bodythemedark .ag-theme-alpine .ag-row {
   background: #000 !important;
 }
 
 .bodythemedark .formbtn {
   background-color: \$addBtn-dark-blue;
 }
 
 .bodythemedark .formbtn:hover {
   background-color: \$addBtn-dark-blue-hover;
 }
 
 .bodythemedark .resetbtn {
   color: \$white-color;
   background-color: transparent;
   border: solid 1px \$addBtn-dark-blue;
 }
 
 
 .headingdark span {
   background-color: \$darkTheme_blue;
 }
 
 .resetbtn {
   font-size: 16px !important;
   font-weight: \$font-semiBold !important;
   border-radius: 5px !important;
   background-color: transparent !important;
   border: solid 1px \$primary-color !important;
   color: \$primary-color !important;
   min-width: 113px !important;
 }
 
 .resetbtn:hover,
 .resetbtn:active,
 .resetbtn:focus {
   background-color: \$primary-color !important;
   color: \$white-color !important;
 }
 
 .addBtn {
   min-width: 140px;
   height: 44px;
   color: \$white-color;
   background-color: \$green-color;
   border: none;
   font-size: 16px;
   font-weight: \$font-semiBold;
 }

  .addDltBtn {
   min-width: 140px;
   height: 44px;
   color: \$white-color;
   background-color: \$green-color;
   border: none;
   font-size: 16px;
   font-weight: \$font-semiBold;
 }
 
 .addbtnlight {
   background-color: \$green-color;
 }
 
 .addbtndark {
   background-color: \$addBtn-dark-blue;
 }
 
 .addbtndark:hover {
   background-color: \$addBtn-dark-blue-hover;
 }
 
 .formthemedark label {
   color: \$dark-light-blue;
 }
 
 
 .addBtn svg {
   margin-right: 10px;
   position: relative;
   top: 2px;
 }
 
 .addBtn:hover {
   color: \$white-color;
   background-color: \$green-color;
   border: none;
 }
 
 .cust_addBtn.addBtn svg {
   top: 2px;
 }
 
 
 .deleteBtn {
   min-width: 130px;
   height: 50px;
   background-color: \$red-color;
   color: \$white-color;
   font-size: 16px;
   font-weight: \$font-semiBold;
   border: none;
 }
 
 .deleteBtn:active,
 .deleteBtn:focus {
   background-color: \$red-color !important;
   color: \$white-color !important;
   box-shadow: none !important;
 }
 
 .deleteBtn svg {
   margin-right: 10px;
   position: relative;
   top: -2px;
 }
 
 .deleteBtn:hover,
 .deleteBtn:active,
 .deleteBtn:focus {
   background-color: \$red-color;
   color: \$white-color;
   border: none;
 }
 
 .confirmBtn {
  min-width: 130px !important;
  height: 50px !important;
  color: \$white-color !important;
  font-size: 16px !important;
  font-weight: \$font-semiBold !important;
  border: none !important;
  background-color: \$primary-color !important;
 }

 .confirmBtn:active,
 .confirmBtn:focus {
   background-color: \$primary-color !important;
   color: \$white-color !important;
   box-shadow: none !important;
 }
 
 .confirmBtn:hover,
 .confirmBtn:active,
 .confirmBtn:focus {
   background-color: \$darkTheme_darkBlue !important;
 }
 
 .confirmBtn svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}
 
 
 
 .delPopContainer .modal-body {
   padding: 35px;
   text-align: center;
 }
 
 .delPopContainer .delet_icon {
   margin-bottom: 11px;
 }
 
 .delPopContainer p {
   color: #131f43;
   font-size: 14px;
   font-weight: 700;
   padding: 0 20px;
 }
 
 .arrowback svg {
   fill: #000;
 }
 
 .bodythemedark .arrowback {
   background-color: \$backBtn-dark;
   color: \$dark-active-blue;
 }
 
 .bodythemedark .arrowback svg {
   fill: \$dark-active-blue;
 }
 
 .bodythemedark .drpdwn_btn {
   background-color: \$darkTheme_blue;
 }
 
 .bodythemedark .empname {
   color: \$dark-light-blue !important;
 }
 
 .bodythemedark .navitemli a {
   background-color: transparent;
   border: solid 1px \$addBtn-dark-blue;
   color: \$white-color;
 }
 
 .bodythemedark .tabnavli a.settingsgeneral,
 .bodythemedark .tabnavli a.settingslinks:hover {
   background-color: \$addBtn-dark-blue;
   color: \$white-color;
 }
 
 .bodythemedark .tabnavli a.settingslinks {
   background-color: transparent;
   border: solid 1px \$addBtn-dark-blue;
   color: \$white-color;
 }
 
 .headerthemedark .dropdown_menu_contain {
   background-color: \$darkTheme_selectBlue;
   color: \$white-color;
 }
 
 .headerthemedark .dropdown_menu_contain ul li a,
 .headerthemedark .dropdown_menu_contain .dropdown_item,
 .headerthemedark .dropdown_menu_contain .dropdown_item h5 {
   color: \$white-color;
 }
 
 .headerthemedark .dropdown_menu_contain ul li a:hover,
 .headerthemedark .dropdown_menu_contain .dropdown_item:hover {
   background-color: \$darkTheme_blue;
   color: \$white-color;
 }
 
 .dropdown_item:active {
   background-color: \$mainBg;
 }
 
 .profile_arrrow_dwn {
   stroke: \$darkTheme_blue;
 }
 
 .headerthemedark .profile_arrrow_dwn {
   stroke: \$white-color;
 }
 
 .dateinputbox1 input,
 .dateinputbox1 span {
   color: \$white-color !important;
 }
 
 /* LOGOUT MODAL */
 .modalStyleLight {}
 
 .modalStyleDark {}
 
 .delPopContainer .modal-content {
   border-radius: 10px;
   min-width: 399px;
 }
 
 .larg_model .modal-dialog {
   max-width: 100% !important;
 }
 
 .larg_model .modal-content {
   /* display: inline-block; */
   height: 100%;
   max-width: 900px;
   margin: auto;
   border-radius: 54px !important;
   background: #FFF;
   padding: 53px 53px 23px;
 }
 
 .larg_model .modal-header {
   padding: 0px 0px 23px;
   border-bottom: 1px dashed #D4D9EE;
   display: block;
 }
 
 body .btn-primary:hover {
   background-color: transparent;
   border-color: #131F43;
   color: #131F43;
   fill: #131F43;
   border: 1px solid;
 }
 
 .form-select {
   display: block;
   width: 100%;
   padding: .375rem 2.25rem .375rem .75rem;
   -moz-padding-start: calc(0.75rem - 3px);
   font-size: 1rem;
   font-weight: 400;
   line-height: 1.5;
   color: #212529;
   background-color: #fff;
   background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
 }
 
 thead .CustomTable_tableheadlight__HuHZw th:first-child,
 thead .CustomTable_tableheaddark__nwqb4 th:first-child {
   border-radius: 5px 0 0 0px;
   display: math;
 }
 
 th:first-child {
   border-radius: 0px;
 }
 
 @media only screen and (max-width: 1200px) {
   .tableheadlight th {
     min-width: 170px;
   }
 }
 
 @media only screen and (max-width: 1024px) {
   .dashboard {
     width: calc(100% - 50px) !important;
     left: 50px !important;
     padding: 10px 10px !important;
     overflow-x: hidden;
   }
 
   .cont2 {
     height: calc(100vh - 160px);
     overflow-y: auto;
   }
 }
 
 @media only screen and (max-width: 998px) {
   /* #dashboardcont2{
     height: auto !important;
   }*/
   /*.tableheadlight th {
     min-width: 200px !important;
   }*/
 }
 
 @media only screen and (max-width: 767px) {
   .sectionright {
     float: unset !important;
   }
 .formthemelight {
   padding: 10px 0!important;
   box-shadow: none !important;
 }
   .dashboard {
     padding: 10px 10px !important;
   }
 }
 
 @media only screen and (max-width: 600px) {
   .cont2 {
     width: \$dashwidth !important;
     left: \$dashleft !important;
     position: relative !important;
     padding: 10px 10px 15px !important;
   }
 
   .bodythemelight,
   .bodythemedark {
     padding-top: 110px;
   }
 
   .delPopContainer .modal-content {
     min-width: 100%;
   }
 
   .delPopContainer .modal-body {
     padding: 15px;
   }
 
   .larg_model .modal-content {
     border-radius: 20px !important;
     padding: 22px;
   }
 }
 
 @media (min-width: 576px) {
   .exer_modal_contain .modal-dialog {
     max-width: 1055px;
   }
 
   .delPopContainer .modal-dialog {
     max-width: 350px;
   }
 
   /*.tableheadlight th {
     min-width: 200px;
   }*/
 }
 
 /* vk new changes */
 .active_show_outer {
 
 h2 {
   color: var(--Font-black, #0B0D0F);
   font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;
   font-size: 22px;
   font-style: normal;
   font-weight: 700;
   line-height: normal;
 }
 
   .active_show_inner {
     width: 100%;
     display: block;
 
     .act_box_img {
       margin-bottom: 12px;
       min-height: 400px;
       object-fit: cover;
       overflow: hidden;
       height: 400px;
       max-height: 400px;
       @media (max-width: 767px) {
         min-height: 300px;
         height: 300px;
         max-height: 300px;
       }
       img {
         max-height: 400px;
         /* align-self: stretch; */
         width: 100%;
         height: 100%;
         border-radius: 12px;
         object-fit: cover;
       }
     }
 
     .act_box_cnt {
       width: 100%;
       display: block;
 svg{
  flex-shrink: 0;
 }
       .act_box_bdg {
         width: 100%;
         margin-bottom: 12px;
 
         span {
           background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right top no-repeat;
           width: 111px;
           display: block;
           height: 34px;
           color: var(--White, #FFF);
           font-size: 18px;
           font-style: normal;
           font-weight: 500;
           padding: 3px 8px;
         }
 
         .sold {
           background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) right top no-repeat !important;
         }
 
       }
 
       h3 {
         color: var(--Secondary, #132941);
         font-size: 18px;
         font-style: normal;
         font-weight: 600;
         line-height: 26.304px;
         margin: 0;
       }
 
       p {
         display: flex;
         align-items: center;
         gap: 10px;
         margin-bottom: 5px;
 
         span {
           color: var(--Light-1, #736B66);
           font-size: 14px;
           font-style: normal;
           font-weight: 500;
           line-height: 26.304px;
         }
       }
     }
   }
 }
 
 /* vk new changes */
 .attent_details {
   .attent_details_inner {
     display: flex;
     gap: 61px;
     padding: 20px;
     border-radius: 5px;
     background: #FFF;
     box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
     align-items: center;
 
     @media (max-width: 576px) {
       display: block !important;
     }
 
     @media (max-width: 992px) {
       display: flex;
       gap: 20px;
       align-items: start;
     }
 
     .attent_details_inner_l {
       img {
         width: 187px;
         height: 207px;
         flex-shrink: 0;
         object-fit: contain;
         @media screen and (max-width:767px) {
          object-fit: contain;
          width: auto;
         }
       }
     }
 
     .attent_details_inner_r {
       flex: 1 1;
 
       .attent_details_row {
         display: flex;
         gap: 20px;
         margin-bottom: 28px;
 
         @media (max-width: 992px) {
           margin-bottom: 0px;
           display: inline-block;
           width: 100%;
         }
 
         .attent_details_row_box {
           flex: 1 1;
           width: 22%;
 
           @media (max-width: 576px) {
             margin: 15px 0px 10px !important;
             width: 100% !important;
           }
 
           @media (max-width: 992px) {
             margin-bottom: 15px;
             float: left;
             margin-right: 0;
             width: 50%;
             padding-right: 10px;
           }
 
           p {
             margin-bottom: 10px;
             color: #727272;
             font-size: 13px;
             font-style: normal;
             font-weight: 600;
             line-height: normal;
           }
 
           h5 {
             color: #131F43;
             font-size: 16px;
             font-style: normal;
             font-weight: 600;
             line-height: normal;
             word-wrap: break-word;
           }
         }
       }
 
      .attent_details_row_last {
        margin-bottom: 0px !important;
        &.interesting_fact {
          padding-top: 30px;
          .attent_details_row_box {
            width: 100%;
            h5 {
              color: #131F43;
              font-size: 16px;
              font-style: normal;
              font-weight: 500;
              line-height: 24px;
            }
          }
        }
      }
     }
   }
 }
 .showbox_sec {
   display: grid;
   grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
   gap: 20px;
   align-items: stretch;
   width: 100%;
   @media screen and (max-width: 500px) {
     grid-template-columns: 1fr;
   }
 }
 .show_box_main {
   margin: 10px 0px;
   width: 100%;

   .show_box {
     min-height: 600px;
     width: 100%;
     margin-bottom: 0;
     cursor: pointer;
     display: flex;
     flex-direction: column;
     box-sizing: border-box;

     @media (max-width: 767px) {
       min-height: 500px;
     }

     .active_show_inner {
       display: flex;
       flex-direction: column;
       flex: 1 1;
       min-height: 0;
     }

     .act_box_img {
       flex-shrink: 0;
     }

     .act_box_cnt {
       flex: 1 1;
       display: flex;
       flex-direction: column;
       min-height: 0;
     }

     img {
       max-height: 400px;
       height: 100%;
       width: 100%;
       object-fit: cover;

       @media (max-width: 767px) {
         max-height: 300px !important;
       }
     }

     &:last-child {
       margin-right: 0;
     }
   }
 
   .no_show_box {
     width: 350px;
     margin: 0 auto 20px;
     display: block;
   
     @media (max-width: 767px) {
       width: 250px !important;
     }
   
     img {
       max-height: 450px;
       height: 100%;
       width: 100%;
   
       @media (max-width: 767px) {
         max-height: 350px !important;
       }
     }
     h6 {
       color: #000;
       text-align: center;
       font-size: 26px;
       font-style: normal;
       font-weight: 700;
       line-height: normal;
       margin-top: 20px;
       @media only screen and (max-width: 600px) {
         font-size: 20px;
       }
     }
   }
   
 
 }
 
 .attent_flex {
   justify-content: space-between !important;
   gap: 30px;
   align-items: center;
 
   h5 {
     font-size: 22px;
     font-style: normal;
     font-weight: 700;
   }
 }
`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss"],"names":[],"mappings":"AAAA;;EAEE;CACD,kBAAkB;CAClB,iBAAiB;CACjB,mBAAmB;CACnB,eAAe;CACf,oBAAoB;CACpB,gBAAgB;;CAEhB,gBAAgB;CAChB,uBAAuB;CACvB,sBAAsB;CACtB,wBAAwB;CACxB,sBAAsB;CACtB,0BAA0B;CAC1B,+BAA+B;CAC/B,sBAAsB;CACtB,0BAA0B;CAC1B,+BAA+B;CAC/B,sBAAsB;CACtB,0BAA0B;CAC1B,+BAA+B;CAC/B,sBAAsB;CACtB,0BAA0B;CAC1B,+BAA+B;CAC/B,yBAAyB;CACzB,yBAAyB;CACzB,yBAAyB;CACzB,qBAAqB;CACrB,yBAAyB;CACzB,2BAA2B;CAC3B,2BAA2B;CAC3B,kBAAkB;CAClB,qBAAqB;CACrB,oBAAoB;CACpB,oBAAoB;CACpB,oBAAoB;CACpB,2BAA2B;CAC3B,0BAA0B;CAC1B,2BAA2B;CAC3B,iCAAiC;CACjC,yBAAyB;;;;CAIzB,yBAAyB;CACzB,6BAA6B;CAC7B,+BAA+B;CAC/B,8BAA8B;;CAE9B;;GAEE;CACF,yBAAyB;CACzB,wBAAwB;;CAExB,kBAAkB;CAClB,qBAAqB;CACrB,yBAAyB;CACzB,wBAAwB;;CAExB;;EAEC;CACD,2BAA2B;;CAE3B;;EAEC;CACD,0BAA0B;CAC1B,8CAA8C;;CAE9C,0BAA0B;;;CAG1B;;EAEC;CACD,mCAAmC;CACnC,4BAA4B;CAC5B,qBAAqB;CACrB,uBAAuB;;CAEvB;;EAEC;CACD,6BAA6B;CAC7B,eAAe;;CAEf;;EAEC;;CAED;GACE,sBAAsB;GACtB,kBAAkB;GAClB,oBAAoB;GACpB,0BAA0B;GAC1B,kBAAkB;GAClB,2BAA2B;GAC3B,yBAAyB;GACzB,gBAAgB;CAClB;;CAEA;GACE,yBAAyB;GACzB,yBAAyB;GACzB,kBAAkB;CACpB;;CAEA;;;GAGE,qCAAqC;CACvC;;CAEA;GACE,6BAA6B;GAC7B,YAAY;GACZ,iBAAiB;CACnB;;CAEA;;EAEC;;CAED;GACE,iBAAiB;GACjB,eAAe;GACf,kBAAkB;GAClB,0BAA0B;GAC1B,kBAAkB;GAClB,mBAAmB;GACnB,+BAA+B;GAC/B,YAAY;GACZ,2BAA2B;GAC3B,gBAAgB;GAChB;;;EAGD;CACD;;CAEA;GACE,kBAAkB;GAClB,SAAS;GACT,UAAU;CACZ;;;;CAIA;GACE,2BAA2B;CAC7B;;CAEA;GACE,yBAAyB;GACzB,YAAY;CACd;;;CAGA;GACE,YAAY;CACd;;CAEA;GACE,8BAA8B;CAChC;;CAEA;;EAEC;CACD;GACE,8BAA8B;GAC9B,iBAAiB;CACnB;;CAEA;GACE,iCAAiC;GACjC,iBAAiB;CACnB;;CAEA;;EAEC;CACD;GACE,8BAA8B;CAChC;;CAEA;GACE,iCAAiC;CACnC;;CAEA;GACE,gBAAgB;GAChB,aAAa;GACb,mBAAmB;GACnB,eAAe;GACf,WAAW;GACX,UAAU;GACV,MAAM;CACR;;CAEA;;EAEC;CACD;GACE,8BAA8B;CAChC;;CAEA;GACE,iCAAiC;CACnC;;CAEA;;EAEC;CACD;GACE,oCAAoC;CACtC;;CAEA;GACE,4BAA4B;CAC9B;;CAEA;;GAEE,8BAA8B;CAChC;;CAEA;GACE,uCAAuC;GACvC,wBAAwB;CAC1B;;CAEA;GACE,sCAAsC;GACtC,8BAA8B;GAC9B,2CAA2C;CAC7C;;CAEA;GACE,kCAAkC;CACpC;;CAEA;GACE,8BAA8B;GAC9B,2CAA2C;CAC7C;;CAEA;GACE,6BAA6B;CAC/B;;CAEA;GACE,+BAA+B;CACjC;;CAEA;GACE,mCAAmC;CACrC;;CAEA;GACE,+BAA+B;CACjC;;CAEA;;GAEE,qBAAqB;CACvB;;CAEA;GACE,uCAAuC;GACvC,mBAAmB;CACrB;;CAEA;;EAEC;CACD;GACE,sBAAsB;CACxB;;CAEA;GACE,sBAAsB;CACxB;;CAEA;;EAEC;CACD;GACE,8BAA8B;GAC9B,YAAY;CACd;;CAEA;GACE,iCAAiC;GACjC,mBAAmB;GACnB,YAAY;CACd;;CAEA;GACE,sBAAsB;CACxB;;CAEA;;EAEC;CACD;GACE,gCAAgC;GAChC,8BAA8B;CAChC;;CAEA;GACE,mBAAmB;CACrB;;CAEA;;GAEE,0BAA0B;CAC5B;;CAEA;;GAEE,0BAA0B;CAC5B;;CAEA;GACE,kBAAkB;CACpB;;CAEA;GACE,kBAAkB;CACpB;;CAEA;GACE,oCAAoC;GACpC,gCAAgC;CAClC;;CAEA;GACE,oCAAoC;GACpC,mBAAmB;CACrB;;CAEA;GACE,yBAAyB;CAC3B;;CAEA;GACE,iBAAiB;CACnB;;CAEA;;GAEE,+BAA+B;GAC/B,iBAAiB;CACnB;;CAEA;GACE,8BAA8B;;GAE9B;KACE,8BAA8B;KAC9B,YAAY;GACd;CACF;;CAEA;GACE,0CAA0C;GAC1C,sBAAsB;;GAEtB;KACE,yCAAyC;KACzC,eAAe;GACjB;CACF;;CAEA;;EAEC;CACD;GACE,iCAAiC;GACjC,0BAA0B;CAC5B;;CAEA;GACE,iCAAiC;GACjC,0BAA0B;CAC5B;;CAEA;;EAEC;CACD;GACE,8BAA8B;GAC9B,8BAA8B;GAC9B,iDAAiD;CACnD;;CAEA;GACE,oCAAoC;GACpC,iCAAiC;GACjC,eAAe;;GAEf;KACE,sBAAsB;GACxB;CACF;;;CAGA;;EAEC;CACD;GACE,kCAAkC;CACpC;;CAEA;GACE,yBAAyB;GACzB,yBAAyB;CAC3B;;CAEA;GACE,qCAAqC;GACrC,yBAAyB;CAC3B;;CAEA;GACE,UAAU;GACV,eAAe;GACf,eAAe;CACjB;;CAEA;;EAEC;CACD;GACE,8BAA8B;CAChC;;CAEA;GACE,oCAAoC;CACtC;;;CAGA;;EAEC;CACD;GACE,iGAAiG;GACjG,8BAA8B;CAChC;;CAEA;GACE,mBAAmB;CACrB;;CAEA;GACE,gGAAgG;GAChG,8BAA8B;CAChC;;CAEA;GACE,mBAAmB;CACrB;;CAEA;GACE,gGAAgG;GAChG,8BAA8B;CAChC;;CAEA;GACE,mBAAmB;CACrB;;CAEA;GACE,gGAAgG;GAChG,8BAA8B;CAChC;;CAEA;GACE,mBAAmB;CACrB;;CAEA;;;;;;;;GAQE,mBAAmB;CACrB;;CAEA;;EAEC;CACD;GACE,gBAAgB;CAClB;;CAEA;GACE,sBAAsB;CACxB;;;CAGA;;EAEC;CACD;GACE,sBAAsB;CACxB;;CAEA;GACE,yBAAyB;CAC3B;;CAEA;GACE,mCAAmC;GACnC,mBAAmB;CACrB;;CAEA;GACE,mCAAmC;GACnC,mBAAmB;CACrB;;CAEA;GACE,6BAA6B;CAC/B;;CAEA;GACE,2BAA2B;CAC7B;;CAEA;GACE,mCAAmC;CACrC;;CAEA;GACE,yCAAyC;CAC3C;;CAEA;GACE,mBAAmB;GACnB,6BAA6B;GAC7B,mCAAmC;CACrC;;;CAGA;GACE,iCAAiC;CACnC;;CAEA;GACE,0BAA0B;GAC1B,sCAAsC;GACtC,6BAA6B;GAC7B,wCAAwC;GACxC,2CAA2C;GAC3C,gCAAgC;GAChC,2BAA2B;CAC7B;;CAEA;;;GAGE,2CAA2C;GAC3C,8BAA8B;CAChC;;CAEA;GACE,gBAAgB;GAChB,YAAY;GACZ,mBAAmB;GACnB,8BAA8B;GAC9B,YAAY;GACZ,eAAe;GACf,2BAA2B;CAC7B;;EAEC;GACC,gBAAgB;GAChB,YAAY;GACZ,mBAAmB;GACnB,8BAA8B;GAC9B,YAAY;GACZ,eAAe;GACf,2BAA2B;CAC7B;;CAEA;GACE,8BAA8B;CAChC;;CAEA;GACE,mCAAmC;CACrC;;CAEA;GACE,yCAAyC;CAC3C;;CAEA;GACE,uBAAuB;CACzB;;;CAGA;GACE,kBAAkB;GAClB,kBAAkB;GAClB,QAAQ;CACV;;CAEA;GACE,mBAAmB;GACnB,8BAA8B;GAC9B,YAAY;CACd;;CAEA;GACE,QAAQ;CACV;;;CAGA;GACE,gBAAgB;GAChB,YAAY;GACZ,4BAA4B;GAC5B,mBAAmB;GACnB,eAAe;GACf,2BAA2B;GAC3B,YAAY;CACd;;CAEA;;GAEE,uCAAuC;GACvC,8BAA8B;GAC9B,2BAA2B;CAC7B;;CAEA;GACE,kBAAkB;GAClB,kBAAkB;GAClB,SAAS;CACX;;CAEA;;;GAGE,4BAA4B;GAC5B,mBAAmB;GACnB,YAAY;CACd;;CAEA;EACC,2BAA2B;EAC3B,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;EAC1B,sCAAsC;EACtC,uBAAuB;EACvB,2CAA2C;CAC5C;;CAEA;;GAEE,2CAA2C;GAC3C,8BAA8B;GAC9B,2BAA2B;CAC7B;;CAEA;;;GAGE,gDAAgD;CAClD;;CAEA;EACC,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;;;;CAIC;GACE,aAAa;GACb,kBAAkB;CACpB;;CAEA;GACE,mBAAmB;CACrB;;CAEA;GACE,cAAc;GACd,eAAe;GACf,gBAAgB;GAChB,eAAe;CACjB;;CAEA;GACE,UAAU;CACZ;;CAEA;GACE,+BAA+B;GAC/B,wBAAwB;CAC1B;;CAEA;GACE,uBAAuB;CACzB;;CAEA;GACE,iCAAiC;CACnC;;CAEA;GACE,kCAAkC;CACpC;;CAEA;GACE,6BAA6B;GAC7B,mCAAmC;GACnC,mBAAmB;CACrB;;CAEA;;GAEE,mCAAmC;GACnC,mBAAmB;CACrB;;CAEA;GACE,6BAA6B;GAC7B,mCAAmC;GACnC,mBAAmB;CACrB;;CAEA;GACE,uCAAuC;GACvC,mBAAmB;CACrB;;CAEA;;;GAGE,mBAAmB;CACrB;;CAEA;;GAEE,iCAAiC;GACjC,mBAAmB;CACrB;;CAEA;GACE,yBAAyB;CAC3B;;CAEA;GACE,uBAAuB;CACzB;;CAEA;GACE,oBAAoB;CACtB;;CAEA;;GAEE,8BAA8B;CAChC;;CAEA,iBAAiB;CACjB,kBAAkB;;CAElB,iBAAiB;;CAEjB;GACE,mBAAmB;GACnB,gBAAgB;CAClB;;CAEA;GACE,0BAA0B;CAC5B;;CAEA;GACE,2BAA2B;GAC3B,YAAY;GACZ,gBAAgB;GAChB,YAAY;GACZ,8BAA8B;GAC9B,gBAAgB;GAChB,uBAAuB;CACzB;;CAEA;GACE,qBAAqB;GACrB,iCAAiC;GACjC,cAAc;CAChB;;CAEA;GACE,6BAA6B;GAC7B,qBAAqB;GACrB,cAAc;GACd,aAAa;GACb,iBAAiB;CACnB;;CAEA;GACE,cAAc;GACd,WAAW;GACX,uCAAuC;GACvC,uCAAuC;GACvC,eAAe;GACf,gBAAgB;GAChB,gBAAgB;GAChB,cAAc;GACd,sBAAsB;GACtB,oEAA8D;CAChE;;CAEA;;GAEE,0BAA0B;GAC1B,aAAa;CACf;;CAEA;GACE,kBAAkB;CACpB;;CAEA;GACE;KACE,gBAAgB;GAClB;CACF;;CAEA;GACE;KACE,mCAAmC;KACnC,qBAAqB;KACrB,6BAA6B;KAC7B,kBAAkB;GACpB;;GAEA;KACE,2BAA2B;KAC3B,gBAAgB;GAClB;CACF;;CAEA;GACE;;KAEE;GACF;;KAEE;CACJ;;CAEA;GACE;KACE,uBAAuB;GACzB;CACF;GACE,yBAAyB;GACzB,2BAA2B;CAC7B;GACE;KACE,6BAA6B;GAC/B;CACF;;CAEA;GACE;KACE,4BAA4B;KAC5B,0BAA0B;KAC1B,6BAA6B;KAC7B,kCAAkC;GACpC;;GAEA;;KAEE,kBAAkB;GACpB;;GAEA;KACE,eAAe;GACjB;;GAEA;KACE,aAAa;GACf;;GAEA;KACE,8BAA8B;KAC9B,aAAa;GACf;CACF;;CAEA;GACE;KACE,iBAAiB;GACnB;;GAEA;KACE,gBAAgB;GAClB;;GAEA;;KAEE;CACJ;;CAEA,mBAAmB;CACnB;;CAEA;GACE,iCAAiC;GACjC,gEAAgE;GAChE,eAAe;GACf,kBAAkB;GAClB,gBAAgB;GAChB,mBAAmB;CACrB;;GAEE;KACE,WAAW;KACX,cAAc;;KAEd;OACE,mBAAmB;OACnB,iBAAiB;OACjB,iBAAiB;OACjB,gBAAgB;OAChB,aAAa;OACb,iBAAiB;OACjB;SACE,iBAAiB;SACjB,aAAa;SACb,iBAAiB;OACnB;OACA;SACE,iBAAiB;SACjB,yBAAyB;SACzB,WAAW;SACX,YAAY;SACZ,mBAAmB;SACnB,iBAAiB;OACnB;KACF;;KAEA;OACE,WAAW;OACX,cAAc;CACpB;EACC,cAAc;CACf;OACM;SACE,WAAW;SACX,mBAAmB;;SAEnB;WACE,uEAA6D;WAC7D,YAAY;WACZ,cAAc;WACd,YAAY;WACZ,yBAAyB;WACzB,eAAe;WACf,kBAAkB;WAClB,gBAAgB;WAChB,gBAAgB;SAClB;;SAEA;WACE,kFAAqE;SACvE;;OAEF;;OAEA;SACE,gCAAgC;SAChC,eAAe;SACf,kBAAkB;SAClB,gBAAgB;SAChB,qBAAqB;SACrB,SAAS;OACX;;OAEA;SACE,aAAa;SACb,mBAAmB;SACnB,SAAS;SACT,kBAAkB;;SAElB;WACE,8BAA8B;WAC9B,eAAe;WACf,kBAAkB;WAClB,gBAAgB;WAChB,qBAAqB;SACvB;OACF;KACF;GACF;CACF;;CAEA,mBAAmB;CACnB;GACE;KACE,aAAa;KACb,SAAS;KACT,aAAa;KACb,kBAAkB;KAClB,gBAAgB;KAChB,gDAAgD;KAChD,mBAAmB;;KAEnB;OACE,yBAAyB;KAC3B;;KAEA;OACE,aAAa;OACb,SAAS;OACT,kBAAkB;KACpB;;KAEA;OACE;SACE,YAAY;SACZ,aAAa;SACb,cAAc;SACd,mBAAmB;SACnB;UACC,mBAAmB;UACnB,WAAW;SACZ;OACF;KACF;;KAEA;OACE,SAAO;;OAEP;SACE,aAAa;SACb,SAAS;SACT,mBAAmB;;SAEnB;WACE,kBAAkB;WAClB,qBAAqB;WACrB,WAAW;SACb;;SAEA;WACE,SAAO;WACP,UAAU;;WAEV;aACE,gCAAgC;aAChC,sBAAsB;WACxB;;WAEA;aACE,mBAAmB;aACnB,WAAW;aACX,eAAe;aACf,UAAU;aACV,mBAAmB;WACrB;;WAEA;aACE,mBAAmB;aACnB,cAAc;aACd,eAAe;aACf,kBAAkB;aAClB,gBAAgB;aAChB,mBAAmB;WACrB;;WAEA;aACE,cAAc;aACd,eAAe;aACf,kBAAkB;aAClB,gBAAgB;aAChB,mBAAmB;aACnB,qBAAqB;WACvB;SACF;OACF;;MAED;QACE,6BAA6B;QAC7B;UACE,iBAAiB;UACjB;YACE,WAAW;YACX;cACE,cAAc;cACd,eAAe;cACf,kBAAkB;cAClB,gBAAgB;cAChB,iBAAiB;YACnB;UACF;QACF;MACF;KACD;GACF;CACF;CACA;GACE,aAAa;GACb,4DAA4D;GAC5D,SAAS;GACT,oBAAoB;GACpB,WAAW;GACX;KACE,0BAA0B;GAC5B;CACF;CACA;GACE,gBAAgB;GAChB,WAAW;;GAEX;KACE,iBAAiB;KACjB,WAAW;KACX,gBAAgB;KAChB,eAAe;KACf,aAAa;KACb,sBAAsB;KACtB,sBAAsB;;KAEtB;OACE,iBAAiB;KACnB;;KAEA;OACE,aAAa;OACb,sBAAsB;OACtB,SAAO;OACP,aAAa;KACf;;KAEA;OACE,cAAc;KAChB;;KAEA;OACE,SAAO;OACP,aAAa;OACb,sBAAsB;OACtB,aAAa;KACf;;KAEA;OACE,iBAAiB;OACjB,YAAY;OACZ,WAAW;OACX,iBAAiB;;OAEjB;SACE,4BAA4B;OAC9B;KACF;;KAEA;OACE,eAAe;KACjB;GACF;;GAEA;KACE,YAAY;KACZ,mBAAmB;KACnB,cAAc;;KAEd;OACE,uBAAuB;KACzB;;KAEA;OACE,iBAAiB;OACjB,YAAY;OACZ,WAAW;;OAEX;SACE,4BAA4B;OAC9B;KACF;KACA;OACE,WAAW;OACX,kBAAkB;OAClB,eAAe;OACf,kBAAkB;OAClB,gBAAgB;OAChB,mBAAmB;OACnB,gBAAgB;OAChB;SACE,eAAe;OACjB;KACF;GACF;;;CAGF;;CAEA;GACE,yCAAyC;GACzC,SAAS;GACT,mBAAmB;;GAEnB;KACE,eAAe;KACf,kBAAkB;KAClB,gBAAgB;GAClB;CACF","sourcesContent":["/* \nscss\n */\n $font-regular: 400;\n $font-medium: 500;\n $font-semiBold: 600;\n $font-bold: 700;\n $font-extraBold: 800;\n $font-black: 900;\n \n $mainBg: #F5F6FA;\n $primary-color: #131F43;\n $icon-bgcolor: #F6F6F6;\n $text-graycolor: #727272;\n $cardIcon1-bg: #F3F4F8;\n $cardIcon1-darkbg: #30231a;\n $cardIcon1-darkbg-icon: #9d785f;\n $cardIcon2-bg: #FAF4FB;\n $cardIcon2-darkbg: #13252a;\n $cardIcon2-darkbg-icon: #3b606a;\n $cardIcon3-bg: #FAF7F3;\n $cardIcon3-darkbg: #2c1a27;\n $cardIcon3-darkbg-icon: #6c4863;\n $cardIcon4-bg: #F5F9FC;\n $cardIcon4-darkbg: #241d3e;\n $cardIcon4-darkbg-icon: #5f538b;\n $cardIcon2-color: #AC44BB;\n $cardIcon3-color: #D69A5F;\n $cardIcon4-color: #176CA5;\n $green-color: #38A169;\n $darkGreen-color: #207a4a;\n $placeholder-color: #666666;\n $profile-dark-text: #181818;\n $heading : #0B0D0F;\n $light-gray : #999999;\n $menu_icon : #CBCBCB;\n $red-color : #F94747;\n $red-hover : #960101;\n $dark-active-blue : #3b82f6;\n $dark-light-blue : #92afd3;\n $addBtn-dark-blue : #3b82f6;\n $addBtn-dark-blue-hover : #2563eb;\n $backBtn-dark : #3b82f633;\n \n \n \n $darkTheme_blue : #132337;\n $darkTheme_darkBlue : #0f1824;\n $darkTheme_selectBlue : #1c2e45;\n $darkTheme_updateBtn : #0a2574;\n \n /* \n Body Theme Color\n  */\n $lightthemecolor: #f3f6f9;\n $darkthemecolor: #151521;\n \n $white-color: #fff;\n $black-color: #1d1d1d;\n $fullBlack-color: #1d1d1d;\n $lightthemetext: #60677e;\n \n /* \n Dark Theme Colors\n */\n $primarydark-color: #132337;\n \n /* \n Button Theme\n */\n $primary-btncolor: #131F43;\n $secondary-btncolor: rgba(37, 105, 109, 0.864);\n \n $tableheadlightbg: #e9eaf0;\n \n \n /* \n Max Dashboard scss\n */\n $dashboardwidth: calc(100% - 320px);\n $dashboardposition: absolute;\n $dashboardleft: 290px;\n $dashboardpadding: 30px;\n \n /* \n Min Dashboard scss\n */\n $dashwidth: calc(100% - 50px);\n $dashleft: 50px;\n \n /* \n Max Dashboard scss\n */\n \n .dashboard {\n   width: $dashboardwidth;\n   position: relative;\n   left: $dashboardleft;\n   padding: $dashboardpadding;\n   border-radius: 8px;\n   min-height: auto !important;\n   background-color: $mainBg;\n   overflow-y: auto;\n }\n \n .dashboardContain {\n   width: calc(100% - 320px);\n   background-Color: $mainBg;\n   border-radius: 8px;\n }\n \n .bodythemedark .dashboardContain,\n .bodythemedark .dashboard,\n .bodythemedark .cont2 {\n   background-Color: $darkTheme_darkBlue;\n }\n \n .top_header .top_header_inner {\n   background-color: transparent;\n   height: auto;\n   overflow-y: unset;\n }\n \n /* \n Min Dashboard scss\n */\n \n .cont2 {\n   width: $dashwidth;\n   left: $dashleft;\n   position: relative;\n   padding: $dashboardpadding;\n   border-radius: 8px;\n   background: $mainBg;\n   /*height: calc(100vh - 160px);*/\n   height: 100%;\n   min-height: auto !important;\n   overflow-y: auto;\n   /* \n background-Color: $dashboardbackgroundColor;\n   padding-bottom: 8%;\n */\n }\n \n .subLink svg {\n   position: relative;\n   top: -2px;\n   left: -7px;\n }\n \n \n \n .cst_vendr input {\n   min-height: 35px !important;\n }\n \n .cst_vendr .form-control {\n   background-color: #f5f6fa;\n   border: none;\n }\n \n \n .footer {\n   height: 70px;\n }\n \n body {\n   background-color: $white-color;\n }\n \n /* \n THEME CHANGE\n */\n .bodythemelight {\n   background-color: $white-color;\n   padding-top: 90px;\n }\n \n .bodythemedark {\n   background-color: $darkTheme_blue;\n   padding-top: 90px;\n }\n \n /* \n Header Navbar Theme\n */\n .headerthemelight {\n   background-color: $white-color;\n }\n \n .headerthemedark {\n   background-color: $darkTheme_blue;\n }\n \n .top_header {\n   min-height: 90px;\n   display: flex;\n   align-items: center;\n   position: fixed;\n   width: 100%;\n   z-index: 2;\n   top: 0;\n }\n \n /* \n LEFT MENU THEME CHANGE\n */\n .menuthemelight {\n   background-color: $white-color;\n }\n \n .menuthemedark {\n   background-color: $darkTheme_blue;\n }\n \n /* \n LEFT MENU LINKS THEME CHANGE\n */\n .menulinklight span {\n   color: $placeholder-color !important;\n }\n \n .menulinklight a {\n   color: $menu_icon !important;\n }\n \n .menulinklight:hover span,\n .menulinklight:hover a {\n   color: $white-color !important;\n }\n \n .menulinkdarkSelected {\n   background-color: $darkTheme_selectBlue;\n   color: $dark-active-blue;\n }\n \n .menuthemelight .menulinklightSelected {\n   /*background-color: $lightthemecolor;*/\n   color: $white-color !important;\n   background-color: $primary-color !important;\n }\n \n .menulinkdark {\n   color: $dark-light-blue !important;\n }\n \n .menulinklight:hover {\n   color: $white-color !important;\n   background-color: $primary-color !important;\n }\n \n .menulinklight .sub_arrow svg path {\n   stroke: $menu_icon !important;\n }\n \n .menulinklight:hover .sub_arrow svg path {\n   stroke: $white-color !important;\n }\n \n .menulinkdark .sub_arrow svg path {\n   stroke: $dark-light-blue !important;\n }\n \n .menulinkdark:hover .sub_arrow svg path {\n   stroke: $white-color !important;\n }\n \n .menulinklight:hover svg path,\n .menulinklightSelected svg path {\n   fill: #fff !important;\n }\n \n .menulinkdark:hover {\n   background-color: $darkTheme_selectBlue;\n   color: $white-color;\n }\n \n /* \n BODY HEADERS\n */\n .headinglight {\n   color: $lightthemetext;\n }\n \n .headingdark {\n   color: $lightthemetext;\n }\n \n /* \n SEARCH BOX THEME COLOR\n */\n .searchboxlight {\n   background-color: $white-color;\n   border: none;\n }\n \n .searchboxdark {\n   background-color: $darkTheme_blue;\n   color: $white-color;\n   border: none;\n }\n \n .searchboxdark::placeholder {\n   color: $lightthemetext;\n }\n \n /* \n CUSTOM TABLE THEME COLOR\n */\n .tableheadlight {\n   background-color: $primary-color;\n   border-radius: 5px 5px 0px 0px;\n }\n \n .tableheadlight th {\n   color: $white-color;\n }\n \n thead .tableheadlight th:first-child,\n thead .tableheaddark th:first-child {\n   border-radius: 5px 0 0 0px;\n }\n \n thead .tableheadlight th:last-child,\n thead .tableheaddark th:last-child {\n   border-radius: 0 5px 0px 0;\n }\n \n th:first-child {\n   border-radius: 0px;\n }\n \n td:last-child {\n   border-radius: 0px;\n }\n \n table.table.table-borderless {\n   border-collapse: separate !important;\n   border-spacing: 0 0px !important;\n }\n \n .tableheaddark {\n   background-color: $primarydark-color;\n   color: $white-color;\n }\n \n .table-borderless tr:nth-child(even) {\n   background-color: #F9FAFB;\n }\n \n .table-borderless .left-section {\n   padding-top: 10px;\n }\n \n .tablebodylight td,\n .tablebodydark td {\n   padding: 0.5rem 1rem !important;\n   line-height: 45px;\n }\n \n .tablebodylight {\n   background-color: $white-color;\n \n   &:hover {\n     background-color: $white-color;\n     cursor: auto;\n   }\n }\n \n .tablebodydark {\n   /* background-color: $primarydark-color; */\n   color: $lightthemetext;\n \n   &:hover {\n     background-color: rgba(33, 150, 243, 0.1);\n     cursor: pointer;\n   }\n }\n \n /* \n PAGINATION THEME COLOR\n */\n .paginationlight {\n   color: $lightthemetext !important;\n   font-size: 13px !important;\n }\n \n .paginationdark {\n   color: $lightthemetext !important;\n   font-size: 13px !important;\n }\n \n /* \n SETTING FORM THEME COLOR\n */\n .formthemelight {\n   background-color: $white-color;\n   color: $black-color !important;\n   box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n }\n \n .formthemedark {\n   background-color: $primarydark-color;\n   color: $lightthemetext !important;\n   font-size: 14px;\n \n   ::placeholder {\n     color: $lightthemetext;\n   }\n }\n \n \n /* \n VIEW FORM DETAILS BOX THEME COLOR\n */\n .viewformlight {\n   background-color: $lightthemecolor;\n }\n \n .permissionboxlight {\n   background-color: #f8f9fa;\n   border: 1px solid #dee2e6;\n }\n \n .permissionboxdark {\n   background-color: $darkTheme_darkBlue;\n   border: solid 1px #242434;\n }\n \n .errormsgclr {\n   color: red;\n   font-size: 14px;\n   margin-top: 5px;\n }\n \n /* \n Graph theme\n */\n .graphclrlight {\n   background-color: $white-color;\n }\n \n .graphclrdark {\n   background-color: $primarydark-color;\n }\n \n \n /* \n Counter theme\n */\n #card1bglight {\n   /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n   background-color: $white-color;\n }\n \n #card1bgdark {\n   background: #392f28;\n }\n \n #card2bglight {\n   /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n   background-color: $white-color;\n }\n \n #card2bgdark {\n   background: #1c3238;\n }\n \n #card3bglight {\n   /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n   background-color: $white-color;\n }\n \n #card3bgdark {\n   background: #3a2434;\n }\n \n #card4bglight {\n   /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n   background-color: $white-color;\n }\n \n #card4bgdark {\n   background: #2f264f;\n }\n \n #card1bgdark a,\n #card1bgdark p,\n #card2bgdark a,\n #card2bgdark p,\n #card3bgdark a,\n #card3bgdark p,\n #card4bgdark a,\n #card4bgdark p {\n   color: $white-color;\n }\n \n /* \n Action button theme\n */\n .actionbtnlight {\n   color: #46475bde;\n }\n \n .actionbtndark {\n   color: $lightthemetext;\n }\n \n \n /* \n profile dropdowntheme\n */\n .profiledropdownlight {\n   background-color: #fff;\n }\n \n .profiledropdowndark {\n   background-color: #151521;\n }\n \n .settingsection #addform.formthemedark .savebtn {\n   background-color: $addBtn-dark-blue;\n   color: $white-color;\n }\n \n #addform.formthemedark .savebtn {\n   background-color: $addBtn-dark-blue;\n   color: $white-color;\n }\n \n .profile_conatiner {\n   border-radius: 5px !important;\n }\n \n .bodythemedark .ag-theme-alpine .ag-row {\n   background: #000 !important;\n }\n \n .bodythemedark .formbtn {\n   background-color: $addBtn-dark-blue;\n }\n \n .bodythemedark .formbtn:hover {\n   background-color: $addBtn-dark-blue-hover;\n }\n \n .bodythemedark .resetbtn {\n   color: $white-color;\n   background-color: transparent;\n   border: solid 1px $addBtn-dark-blue;\n }\n \n \n .headingdark span {\n   background-color: $darkTheme_blue;\n }\n \n .resetbtn {\n   font-size: 16px !important;\n   font-weight: $font-semiBold !important;\n   border-radius: 5px !important;\n   background-color: transparent !important;\n   border: solid 1px $primary-color !important;\n   color: $primary-color !important;\n   min-width: 113px !important;\n }\n \n .resetbtn:hover,\n .resetbtn:active,\n .resetbtn:focus {\n   background-color: $primary-color !important;\n   color: $white-color !important;\n }\n \n .addBtn {\n   min-width: 140px;\n   height: 44px;\n   color: $white-color;\n   background-color: $green-color;\n   border: none;\n   font-size: 16px;\n   font-weight: $font-semiBold;\n }\n\n  .addDltBtn {\n   min-width: 140px;\n   height: 44px;\n   color: $white-color;\n   background-color: $green-color;\n   border: none;\n   font-size: 16px;\n   font-weight: $font-semiBold;\n }\n \n .addbtnlight {\n   background-color: $green-color;\n }\n \n .addbtndark {\n   background-color: $addBtn-dark-blue;\n }\n \n .addbtndark:hover {\n   background-color: $addBtn-dark-blue-hover;\n }\n \n .formthemedark label {\n   color: $dark-light-blue;\n }\n \n \n .addBtn svg {\n   margin-right: 10px;\n   position: relative;\n   top: 2px;\n }\n \n .addBtn:hover {\n   color: $white-color;\n   background-color: $green-color;\n   border: none;\n }\n \n .cust_addBtn.addBtn svg {\n   top: 2px;\n }\n \n \n .deleteBtn {\n   min-width: 130px;\n   height: 50px;\n   background-color: $red-color;\n   color: $white-color;\n   font-size: 16px;\n   font-weight: $font-semiBold;\n   border: none;\n }\n \n .deleteBtn:active,\n .deleteBtn:focus {\n   background-color: $red-color !important;\n   color: $white-color !important;\n   box-shadow: none !important;\n }\n \n .deleteBtn svg {\n   margin-right: 10px;\n   position: relative;\n   top: -2px;\n }\n \n .deleteBtn:hover,\n .deleteBtn:active,\n .deleteBtn:focus {\n   background-color: $red-color;\n   color: $white-color;\n   border: none;\n }\n \n .confirmBtn {\n  min-width: 130px !important;\n  height: 50px !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n  background-color: $primary-color !important;\n }\n\n .confirmBtn:active,\n .confirmBtn:focus {\n   background-color: $primary-color !important;\n   color: $white-color !important;\n   box-shadow: none !important;\n }\n \n .confirmBtn:hover,\n .confirmBtn:active,\n .confirmBtn:focus {\n   background-color: $darkTheme_darkBlue !important;\n }\n \n .confirmBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n \n \n \n .delPopContainer .modal-body {\n   padding: 35px;\n   text-align: center;\n }\n \n .delPopContainer .delet_icon {\n   margin-bottom: 11px;\n }\n \n .delPopContainer p {\n   color: #131f43;\n   font-size: 14px;\n   font-weight: 700;\n   padding: 0 20px;\n }\n \n .arrowback svg {\n   fill: #000;\n }\n \n .bodythemedark .arrowback {\n   background-color: $backBtn-dark;\n   color: $dark-active-blue;\n }\n \n .bodythemedark .arrowback svg {\n   fill: $dark-active-blue;\n }\n \n .bodythemedark .drpdwn_btn {\n   background-color: $darkTheme_blue;\n }\n \n .bodythemedark .empname {\n   color: $dark-light-blue !important;\n }\n \n .bodythemedark .navitemli a {\n   background-color: transparent;\n   border: solid 1px $addBtn-dark-blue;\n   color: $white-color;\n }\n \n .bodythemedark .tabnavli a.settingsgeneral,\n .bodythemedark .tabnavli a.settingslinks:hover {\n   background-color: $addBtn-dark-blue;\n   color: $white-color;\n }\n \n .bodythemedark .tabnavli a.settingslinks {\n   background-color: transparent;\n   border: solid 1px $addBtn-dark-blue;\n   color: $white-color;\n }\n \n .headerthemedark .dropdown_menu_contain {\n   background-color: $darkTheme_selectBlue;\n   color: $white-color;\n }\n \n .headerthemedark .dropdown_menu_contain ul li a,\n .headerthemedark .dropdown_menu_contain .dropdown_item,\n .headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n   color: $white-color;\n }\n \n .headerthemedark .dropdown_menu_contain ul li a:hover,\n .headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n   background-color: $darkTheme_blue;\n   color: $white-color;\n }\n \n .dropdown_item:active {\n   background-color: $mainBg;\n }\n \n .profile_arrrow_dwn {\n   stroke: $darkTheme_blue;\n }\n \n .headerthemedark .profile_arrrow_dwn {\n   stroke: $white-color;\n }\n \n .dateinputbox1 input,\n .dateinputbox1 span {\n   color: $white-color !important;\n }\n \n /* LOGOUT MODAL */\n .modalStyleLight {}\n \n .modalStyleDark {}\n \n .delPopContainer .modal-content {\n   border-radius: 10px;\n   min-width: 399px;\n }\n \n .larg_model .modal-dialog {\n   max-width: 100% !important;\n }\n \n .larg_model .modal-content {\n   /* display: inline-block; */\n   height: 100%;\n   max-width: 900px;\n   margin: auto;\n   border-radius: 54px !important;\n   background: #FFF;\n   padding: 53px 53px 23px;\n }\n \n .larg_model .modal-header {\n   padding: 0px 0px 23px;\n   border-bottom: 1px dashed #D4D9EE;\n   display: block;\n }\n \n body .btn-primary:hover {\n   background-color: transparent;\n   border-color: #131F43;\n   color: #131F43;\n   fill: #131F43;\n   border: 1px solid;\n }\n \n .form-select {\n   display: block;\n   width: 100%;\n   padding: .375rem 2.25rem .375rem .75rem;\n   -moz-padding-start: calc(0.75rem - 3px);\n   font-size: 1rem;\n   font-weight: 400;\n   line-height: 1.5;\n   color: #212529;\n   background-color: #fff;\n   background-image: url(../../assets/select_arow.svg) !important;\n }\n \n thead .CustomTable_tableheadlight__HuHZw th:first-child,\n thead .CustomTable_tableheaddark__nwqb4 th:first-child {\n   border-radius: 5px 0 0 0px;\n   display: math;\n }\n \n th:first-child {\n   border-radius: 0px;\n }\n \n @media only screen and (max-width: 1200px) {\n   .tableheadlight th {\n     min-width: 170px;\n   }\n }\n \n @media only screen and (max-width: 1024px) {\n   .dashboard {\n     width: calc(100% - 50px) !important;\n     left: 50px !important;\n     padding: 10px 10px !important;\n     overflow-x: hidden;\n   }\n \n   .cont2 {\n     height: calc(100vh - 160px);\n     overflow-y: auto;\n   }\n }\n \n @media only screen and (max-width: 998px) {\n   /* #dashboardcont2{\n     height: auto !important;\n   }*/\n   /*.tableheadlight th {\n     min-width: 200px !important;\n   }*/\n }\n \n @media only screen and (max-width: 767px) {\n   .sectionright {\n     float: unset !important;\n   }\n .formthemelight {\n   padding: 10px 0!important;\n   box-shadow: none !important;\n }\n   .dashboard {\n     padding: 10px 10px !important;\n   }\n }\n \n @media only screen and (max-width: 600px) {\n   .cont2 {\n     width: $dashwidth !important;\n     left: $dashleft !important;\n     position: relative !important;\n     padding: 10px 10px 15px !important;\n   }\n \n   .bodythemelight,\n   .bodythemedark {\n     padding-top: 110px;\n   }\n \n   .delPopContainer .modal-content {\n     min-width: 100%;\n   }\n \n   .delPopContainer .modal-body {\n     padding: 15px;\n   }\n \n   .larg_model .modal-content {\n     border-radius: 20px !important;\n     padding: 22px;\n   }\n }\n \n @media (min-width: 576px) {\n   .exer_modal_contain .modal-dialog {\n     max-width: 1055px;\n   }\n \n   .delPopContainer .modal-dialog {\n     max-width: 350px;\n   }\n \n   /*.tableheadlight th {\n     min-width: 200px;\n   }*/\n }\n \n /* vk new changes */\n .active_show_outer {\n \n h2 {\n   color: var(--Font-black, #0B0D0F);\n   font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;\n   font-size: 22px;\n   font-style: normal;\n   font-weight: 700;\n   line-height: normal;\n }\n \n   .active_show_inner {\n     width: 100%;\n     display: block;\n \n     .act_box_img {\n       margin-bottom: 12px;\n       min-height: 400px;\n       object-fit: cover;\n       overflow: hidden;\n       height: 400px;\n       max-height: 400px;\n       @media (max-width: 767px) {\n         min-height: 300px;\n         height: 300px;\n         max-height: 300px;\n       }\n       img {\n         max-height: 400px;\n         /* align-self: stretch; */\n         width: 100%;\n         height: 100%;\n         border-radius: 12px;\n         object-fit: cover;\n       }\n     }\n \n     .act_box_cnt {\n       width: 100%;\n       display: block;\n svg{\n  flex-shrink: 0;\n }\n       .act_box_bdg {\n         width: 100%;\n         margin-bottom: 12px;\n \n         span {\n           background: url(../../assets/ongoing.png) right top no-repeat;\n           width: 111px;\n           display: block;\n           height: 34px;\n           color: var(--White, #FFF);\n           font-size: 18px;\n           font-style: normal;\n           font-weight: 500;\n           padding: 3px 8px;\n         }\n \n         .sold {\n           background: url(../../assets/sold.png) right top no-repeat !important;\n         }\n \n       }\n \n       h3 {\n         color: var(--Secondary, #132941);\n         font-size: 18px;\n         font-style: normal;\n         font-weight: 600;\n         line-height: 26.304px;\n         margin: 0;\n       }\n \n       p {\n         display: flex;\n         align-items: center;\n         gap: 10px;\n         margin-bottom: 5px;\n \n         span {\n           color: var(--Light-1, #736B66);\n           font-size: 14px;\n           font-style: normal;\n           font-weight: 500;\n           line-height: 26.304px;\n         }\n       }\n     }\n   }\n }\n \n /* vk new changes */\n .attent_details {\n   .attent_details_inner {\n     display: flex;\n     gap: 61px;\n     padding: 20px;\n     border-radius: 5px;\n     background: #FFF;\n     box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);\n     align-items: center;\n \n     @media (max-width: 576px) {\n       display: block !important;\n     }\n \n     @media (max-width: 992px) {\n       display: flex;\n       gap: 20px;\n       align-items: start;\n     }\n \n     .attent_details_inner_l {\n       img {\n         width: 187px;\n         height: 207px;\n         flex-shrink: 0;\n         object-fit: contain;\n         @media screen and (max-width:767px) {\n          object-fit: contain;\n          width: auto;\n         }\n       }\n     }\n \n     .attent_details_inner_r {\n       flex: 1;\n \n       .attent_details_row {\n         display: flex;\n         gap: 20px;\n         margin-bottom: 28px;\n \n         @media (max-width: 992px) {\n           margin-bottom: 0px;\n           display: inline-block;\n           width: 100%;\n         }\n \n         .attent_details_row_box {\n           flex: 1;\n           width: 22%;\n \n           @media (max-width: 576px) {\n             margin: 15px 0px 10px !important;\n             width: 100% !important;\n           }\n \n           @media (max-width: 992px) {\n             margin-bottom: 15px;\n             float: left;\n             margin-right: 0;\n             width: 50%;\n             padding-right: 10px;\n           }\n \n           p {\n             margin-bottom: 10px;\n             color: #727272;\n             font-size: 13px;\n             font-style: normal;\n             font-weight: 600;\n             line-height: normal;\n           }\n \n           h5 {\n             color: #131F43;\n             font-size: 16px;\n             font-style: normal;\n             font-weight: 600;\n             line-height: normal;\n             word-wrap: break-word;\n           }\n         }\n       }\n \n      .attent_details_row_last {\n        margin-bottom: 0px !important;\n        &.interesting_fact {\n          padding-top: 30px;\n          .attent_details_row_box {\n            width: 100%;\n            h5 {\n              color: #131F43;\n              font-size: 16px;\n              font-style: normal;\n              font-weight: 500;\n              line-height: 24px;\n            }\n          }\n        }\n      }\n     }\n   }\n }\n .showbox_sec {\n   display: grid;\n   grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n   gap: 20px;\n   align-items: stretch;\n   width: 100%;\n   @media screen and (max-width: 500px) {\n     grid-template-columns: 1fr;\n   }\n }\n .show_box_main {\n   margin: 10px 0px;\n   width: 100%;\n\n   .show_box {\n     min-height: 600px;\n     width: 100%;\n     margin-bottom: 0;\n     cursor: pointer;\n     display: flex;\n     flex-direction: column;\n     box-sizing: border-box;\n\n     @media (max-width: 767px) {\n       min-height: 500px;\n     }\n\n     .active_show_inner {\n       display: flex;\n       flex-direction: column;\n       flex: 1;\n       min-height: 0;\n     }\n\n     .act_box_img {\n       flex-shrink: 0;\n     }\n\n     .act_box_cnt {\n       flex: 1;\n       display: flex;\n       flex-direction: column;\n       min-height: 0;\n     }\n\n     img {\n       max-height: 400px;\n       height: 100%;\n       width: 100%;\n       object-fit: cover;\n\n       @media (max-width: 767px) {\n         max-height: 300px !important;\n       }\n     }\n\n     &:last-child {\n       margin-right: 0;\n     }\n   }\n \n   .no_show_box {\n     width: 350px;\n     margin: 0 auto 20px;\n     display: block;\n   \n     @media (max-width: 767px) {\n       width: 250px !important;\n     }\n   \n     img {\n       max-height: 450px;\n       height: 100%;\n       width: 100%;\n   \n       @media (max-width: 767px) {\n         max-height: 350px !important;\n       }\n     }\n     h6 {\n       color: #000;\n       text-align: center;\n       font-size: 26px;\n       font-style: normal;\n       font-weight: 700;\n       line-height: normal;\n       margin-top: 20px;\n       @media only screen and (max-width: 600px) {\n         font-size: 20px;\n       }\n     }\n   }\n   \n \n }\n \n .attent_flex {\n   justify-content: space-between !important;\n   gap: 30px;\n   align-items: center;\n \n   h5 {\n     font-size: 22px;\n     font-style: normal;\n     font-weight: 700;\n   }\n }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
